{
  "tabs": {
    "lambSummary": "Summary of Lamb Scans",
    "beefSummary": "Summary of Beef Scans",
    "shiftScores": "Shift Scores"
  },
  "sitePicker": {
    "label": "Site"
  },
  "shiftScores": {
    "windowHours": "Last {{count}}h",
    "updatedAt": "Updated {{time}}",
    "autoRefresh": "refreshes every minute",
    "unknownOperator": "unknown",
    "overview": {
      "graders": "Graders on shift",
      "activeLastHour": "{{count}} active in the last hour",
      "scans": "Scans",
      "avgScore": "Avg score",
      "aboveWarn": "Above {{value}}",
      "lastHourAvg": "Last hour avg"
    },
    "card": {
      "scans": "{{formatted}} scans",
      "score": "Score",
      "lastHour": "last hour",
      "vsShift": "vs shift",
      "steady": "steady",
      "firstScan": "First scan {{time}}",
      "lastScan": "Last scan {{time}}",
      "scansSeries": "Scans",
      "trend": "Trend",
      "resetZoom": "Reset zoom",
      "bands": {
        "good": "{{value}} and up",
        "mid": "{{low}}–{{high}}",
        "low": "below {{value}}"
      },
      "active": "active",
      "aboveWarn": "{{pct}}% ≥ {{value}}"
    },
    "target": "target {{value}}%"
  },
  "summaryOfScans": {
    "title": {
      "lamb": "Summary of Lamb Scans",
      "beef": "Summary of Beef Scans"
    },
    "dateRange": "Date range",
    "columns": {
      "date": "Date",
      "scans": "Scans",
      "avgImf": "Avg IMF",
      "avgScanScore": "Avg Scan Score",
      "avgMsa": "Avg MSA",
      "avgAus": "Avg AUS",
      "avgUsda": "Avg USDA",
      "imf": "IMF",
      "scanScore": "Scan Score",
      "msa": "MSA",
      "aus": "AUS",
      "usda": "USDA",
      "scanTime": "Scan Time",
      "chain": "Chain",
      "probe": "Probe",
      "scanId": "Scan ID",
      "actions": "Actions"
    },
    "viewDetails": "View details",
    "viewScansFor": "View scans for {{date}}",
    "downloadDay": "Download day CSV",
    "listOfScans": "List of scans",
    "scanCount_one": "{{count}} scan",
    "scanCount_other": "{{count}} scans",
    "close": "Close",
    "noScansToDownload": "No scans to download for this day",
    "downloadError": "Failed to download CSV. Please try again."
  }
}
